import axios from 'axios'
import store from '~/store'
import router from '~/router'
import swal from 'sweetalert2'
import _ from 'lodash'

// Request interceptor
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token']
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  const locale = store.getters['lang/locale']
  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
})

// Response interceptor
axios.interceptors.response.use(response => response, error => {
  const { response, config } = error
  const { status, data } = response

  if (status >= 500) {
    // Quick fix for authentification error on speedy requests
    if ( data.file && data.file.includes('Hmac.php') ) {
      return axios.request(config);
    }
    // Quick fix for slow servers returning blank error messages
    if ( response.message && response.message.includes('Server Error' ) ) {
      return axios.request(config);
    }
    swal({
      type: 'error',
      title: 'エラーが発生しました！',
      text: 'エラーが発生しました。もう一度やり直してください。',
      reverseButtons: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'キャンセル'
    })
  }

  if (status === 401 && store.getters['auth/check']) {
    swal({
      type: 'warning',
      title: 'セッションの期限が切れました！',
      text: "再度ログインでしてください。",
      reverseButtons: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'キャンセル'
    }).then(() => {
      store.commit('auth/LOGOUT')

      router.push({ name: 'login' })
    })
  }

  if (status === 422) {
    let errors_text = ''
    if ( data && data.errors ) {
      _.forOwn(data.errors, function(value, key) {
        errors_text += value + '<br>'
      })
    }
    swal({
      type: 'error',
      title: '必須項目に記入してください',
      html: errors_text,
      reverseButtons: true,
      confirmButtonText:  'OK',
      cancelButtonText:  'キャンセル'
    })
  }

  if (status === 404) {
    router.replace({ path: '/NotFound' })
  }

  return Promise.reject(error)
})


// WEBPACK FOOTER //
// ./resources/js/plugins/axios.js